import LdaDocument from './components/LdaDocument';
import { printDocument } from '../../shared/documents/documentPrint';

const safeFilePart = (value, fallback) => String(value || fallback)
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[^a-zA-Z0-9_-]+/g, '_')
  .replace(/^_+|_+$/g, '');

export const buildLdaFileName = (project = {}) => {
  const reference = safeFilePart(project.code || project.reference || project.projectCode || project.project_code, 'PRJ');
  return `${reference}_LDA.pdf`;
};

export const printLdaDocument = async ({ project, rows }) => {
  const fileName = buildLdaFileName(project);
  await printDocument({
    element: <LdaDocument project={project} rows={rows} />,
    title: fileName.replace(/\.pdf$/i, ''),
    orientation: 'landscape',
  });
  return fileName;
};
